import { PrescriptionSalesItemModel, SalesItemModel } from "@/apidtos";
import { useApi } from "@core/api";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Badge } from "@core/components/ui/badge";
import { LoadingOverlay } from "@core/components/ui/loading-overlay";
import Spinner from "@core/components/ui/Spinner";
import { TableCell, TableHead } from "@core/components/ui/table";
import { Link } from "@remix-run/react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface IMedCartExtensionProps {
  salesItem: SalesItemModel;
  index: number;
}
const MedCartExtensionTableHead = () => {
  const { t } = useTranslation();
  return (
    <>
      <TableHead className="hidden sm:table-cell">
        {t("ui.med.patient", "Patient")}
      </TableHead>
      <TableCell className="sm:hidden py-[0px] pl-[0px] me-2">
        {t("ui.med.patient", "Patient")}:
      </TableCell>
    </>
  );
};

const MedCartExtensionTableRow = ({ salesItem }: IMedCartExtensionProps) => {
  const api = useApi();
  const { t } = useTranslation();

  const patientQuery = useQuery<PrescriptionSalesItemModel>({
    queryKey: ["patient", "salesItem", salesItem.Id],
    queryFn: async () => {
      return await api.GetProviderPrescriptionSalesItemBySalesItemId(salesItem.Id);
    },
  })
  if (patientQuery.isLoading) {
    return (
      <>
        <TableCell className="hidden sm:table-cell">
          <LoadingOverlay className="text-xs relative bg-transparent w-fit h-fit" />
        </TableCell>
        <TableCell className="sm:hidden p-[0px] ml-2">
          <Spinner className="text-[8px] -mt-2" />
        </TableCell>
      </>
    );
  }
  if (patientQuery.isError || !patientQuery.data) {
    return (
      <>
        <TableCell className="relative hidden sm:table-cell">
          N/A
        </TableCell>
        <TableCell className="relative sm:hidden p-[0px]">
          N/A
        </TableCell>
      </>
    );
  }
  const type = salesItem.Tags?.find((tag) => tag.Key === "ShippingOption")?.Value;

  const getInnerContent = () => {
    return <div className="flex flex-row flex-wrap gap-2">
      <Badge className="text-nowrap w-min"
        variant="outline">
        <Link className="text-[var(--link-color)]"
          to={`/dashboard/patient/${(patientQuery.data as PrescriptionSalesItemModel).PrescriptionPatientId}`}>
          {(patientQuery.data as PrescriptionSalesItemModel).PrescriptionPatientName}
        </Link>
      </Badge>
      {type != null && (
        <Badge className="text-nowrap w-min"
          variant="outline">
          {type}
        </Badge>
      )}
      {(patientQuery.data as PrescriptionSalesItemModel).PatientPay && (
        <Badge className="text-nowrap w-min"
          variant="outline">
          {t("ui.med.patient.pay", "Patient Pay")}
        </Badge>
      )}
    </div>;
  };

  return (
    <>
      <TableCell className="hidden sm:table-cell">
        {getInnerContent()}
      </TableCell>
      <span className="sm:hidden">
        {getInnerContent()}
      </span>
    </>
  );
};

registerExtension("_site.cart.route.table.header", MedCartExtensionTableHead, "MedCartExtensionTableHead");
registerExtension("_site.cart.route.table.row", MedCartExtensionTableRow, "MedCartExtensionTableRow");
